import React from 'react';

export const CondensedHamburguerMenu: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <svg
      width="5"
      height="22"
      viewBox="0 0 5 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 5.5C3.88071 5.5 5 4.38071 5 3C5 1.61929 3.88071 0.5 2.5 0.5C1.11929 0.5 0 1.61929 0 3C0 4.38071 1.11929 5.5 2.5 5.5Z"
        fill="currentColor"
      />
      <path
        d="M2.5 13.5C3.88071 13.5 5 12.3807 5 11C5 9.61929 3.88071 8.5 2.5 8.5C1.11929 8.5 0 9.61929 0 11C0 12.3807 1.11929 13.5 2.5 13.5Z"
        fill="currentColor"
      />
      <path
        d="M2.5 21.5C3.88071 21.5 5 20.3807 5 19C5 17.6193 3.88071 16.5 2.5 16.5C1.11929 16.5 0 17.6193 0 19C0 20.3807 1.11929 21.5 2.5 21.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
